import { handleKeyDown, lrListofTrip } from "_services";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { UserContext } from "context";
import { contractRateApi } from "features";
import { Checkbox } from "pages/User/AddUser";
import React, { useEffect, useState, useCallback, useMemo } from "react";

const LrFreightModal2 = (props) => {
  const {
    separateLr,
    listOfFreight,
    setListOfFreight,
    formValue,
    ownerShip,
    isOpen,
    loading, setLoading
  } = props;
  const { masterData } = React.useContext(UserContext);
  const [newResponse, setNewResponse] = useState([]);



  const freightTYpeList = [
    { id: 6, name: "Flat Rate" },
    { id: 1, name: "Per KOT" },
    { id: 3, name: "Per KG" },
    { id: 4, name: "Per QTY" },
    { id: 5, name: "Per KMs" },

  ];

  const filteredArray1 = useMemo(() => {
    return separateLr
      .filter((item) => item._id)
      .map((item) => ({
        consignor_id: item?.consignor_Newid,
        lr_id: item?.lr_id,
      }));
  }, [separateLr]);

  const fetchContractRates = useCallback(async () => {
    setLoading(true);
    try {
      const res = await contractRateApi({
        company_id: formValue.company_id,
        lorry_type_id: formValue?.lorry_type_id,
        vehicle_type_id: formValue?.vehicle_type_id,
        vehicle_ownership: ownerShip,
        vehicle_id: formValue?.vehicle_id,
        supplier_id: formValue?.supplier_id,
        // select_consignor_lr: lr_freight,
        lr_freight: filteredArray1,
      });
      let newRes = [];
      if (res?.responseCode === 200) {
        const newRes = [...res?.data?.final_lr_list];

        const skippedItems = [];
        separateLr.forEach((sepItem) => {
          // Skip items that have _id
          if (sepItem._id) return;

          // Find the matching entry in newRes
          let matchingEntry = newRes?.find(
            (lrItem) => lrItem.consignor_id === sepItem.consignor_Newid
          );

          if (matchingEntry) {
            // If a match is found, add sepItem to lr_list
            matchingEntry.lr_list.push(({ ...sepItem, contract_rates: newRes[0]?.lr_list[0]?.contract_rates, }));

          } else {
            // If no match, create a new entry in newRes
            const templateEntry = newRes[0] || {};

            // Process contract object separately if it exists
            let contractTemplate = templateEntry.contract || {};
            let newContract = Object.fromEntries(
              Object.entries(contractTemplate).map(([key, value]) => {
                if (typeof value === "number" || key === "rate_type") {
                  return [key, value]; // Keep numeric values and rate_type
                }
                return [key, ""]; // Set other fields to empty string
              })
            );

            // Create a new entry with empty values except for rate_type & numeric values
            const newEntry = Object.fromEntries(
              Object.entries(templateEntry).map(([key, value]) => {
                if (key === "rate_type" || typeof value === "number") {
                  return [key, value]; // Keep numeric values and rate_type
                }
                return [key, ""]; // Set other fields to empty string
              })
            );

            // Add contract object and necessary properties
            newEntry.contract = newContract;
            newEntry.consignor_id = sepItem.consignor_Newid;
            newEntry.lr_list = [sepItem];
            newRes.push(newEntry);
          }
        });

        newRes.map((sepItem) => {

          if (sepItem?.contract?.consignor_id) {
            sepItem.lr_list.forEach((lr) => {
              const match = separateLr.find((s) => {
                if (!s._id) return;
                return s._id === lr._id;
              });

              if (match) {
                lr.tableIndex = match.tableIndex;
              }
            });
          }
        });

        setNewResponse(newRes);

        const updatedData = newRes.map((consignor) => {

          const isHighestFreight = consignor?.contract
            ? consignor?.contract?.highest_freight === 1
            : false;
          const multipleRatesAllowed = consignor?.contract
            ? consignor?.contract?.multiple_rates_allowed === 1
            : false;

          const highestFreight = isHighestFreight
            ? Math.max(
              ...consignor?.lr_list.map((lr) =>
                lr?.contract_rates?.total_freight
                  ? lr?.contract_rates?.total_freight
                  : 0
              )
            )
            : 0;

          let firstSelected = false;

          return {
            ...consignor,
            lr_list: consignor.lr_list.map((lr, index) => {
              const isFirstLR = index === 0;
              let isSelected = isFirstLR; // By default, select the first LR.

              // If there's only one LR, select it automatically.
              if (consignor.lr_list.length === 1) {
                isSelected = true;
              }

              // Logic for highest freight
              if (
                isHighestFreight &&
                lr.contract_rates?.total_freight === highestFreight &&
                !firstSelected
              ) {

                isSelected = true;
                firstSelected = true; // Ensure only one highest freight LR is selected.
              }

              // Handle multiple rates allowed condition
              if (multipleRatesAllowed) {
                // Allow other checkboxes to be checked, even if highest freight is selected.
                if (isHighestFreight) {
                  isSelected =
                    lr.contract_rates?.total_freight === highestFreight
                }
              } else {
                // If multiple rates are not allowed, only select the highest freight
                if (
                  isHighestFreight &&
                  lr.contract_rates?.total_freight !== highestFreight
                ) {
                  isSelected = false; // Deselect if not the highest freight.
                }
              }

              // return {
              //   ...lr,
              //   ...(lr.contract_rates?.freight_type
              //     ? {
              //       contract_rates: {
              //         ...lr.contract_rates,
              //         qty: 0,
              //         selected: isSelected,
              //       },
              //     }
              //     : {
              //       contract_rates: {
              //         freight_type: 6,
              //         qty: 0,
              //         rate: 0,
              //         selected: false,
              //         total_freight: 0,
              //       },
              //     }),
              //   ...(lr.lr_freight?.freight_type
              //     ? {
              //       lr_freight: {
              //         ...lr.lr_freight,
              //         // qty: 0,
              //         selected: isSelected,
              //       },
              //     }
              //     : {
              //       lr_freight: {
              //         freight_type: 6,
              //         qty: 0,
              //         rate: 0,
              //         selected: false,
              //         total_freight: 0,
              //       },
              //     }),

              // };

              return {
                ...lr,
                // Handle contract_rates
                ...(lr.contract_rates?.freight_type
                  ? {
                    contract_rates: {
                      ...lr.contract_rates,
                      // Check if freight_type matches any _id in contract.rate_type array
                      ...(Array.isArray(consignor?.contract.rate_type) &&
                        consignor?.contract.rate_type.some(type => type.id === lr.contract_rates.freight_type)
                        ? {
                          selected: isSelected,
                          qty: 0, // assuming you reset qty
                          // Keep other existing values
                        }
                        : {
                          // Not allowed: reset to default
                          freight_type: 6,
                          qty: 0,
                          rate: 0,
                          total_freight: 0,
                          selected: isSelected,
                        }),
                    },
                  }
                  : {
                    contract_rates: {
                      freight_type: 6,
                      qty: 0,
                      rate: 0,
                      total_freight: 0,
                      selected: false,
                    },
                  }),
                // Handle lr_freight
                ...(lr.lr_freight?.freight_type
                  ? {
                    lr_freight: {
                      ...lr.lr_freight,
                      // Same check for lr_freight
                      ...(Array.isArray(consignor?.contract.rate_type) &&
                        consignor?.contract.rate_type.some(type => type.id === lr.lr_freight.freight_type)
                        ? {
                          selected: isSelected,
                          // qty: 0,
                        }
                        : {
                          // Reset if not matched
                          freight_type: 6,
                          qty: 0,
                          rate: 0,
                          total_freight: 0,
                          selected: isSelected,
                        }),
                    },
                  }
                  : {
                    lr_freight: {
                      freight_type: 6,
                      qty: 0,
                      rate: 0,
                      total_freight: 0,
                      selected: false,
                    },
                  }),
              };
            }),
          };
        });

        setListOfFreight(updatedData);
      } else {
        newRes = separateLr.map((sepItem) => ({
          consignor_id: sepItem.consignor_Newid,
          contract: "",
          lr_list: [sepItem],
        }));

        setNewResponse(newRes);

        const updatedData = newRes.map((consignor) => {
          const isHighestFreight = consignor?.contract
            ? consignor?.contract?.highest_freight === 1
            : false;
          const multipleRatesAllowed = consignor?.contract
            ? consignor?.contract?.multiple_rates_allowed === 1
            : false;

          const highestFreight = isHighestFreight
            ? Math.max(
              ...consignor?.lr_list.map((lr) =>
                lr?.contract_rates?.total_freight
                  ? lr?.contract_rates?.total_freight
                  : 0
              )
            )
            : 0;

          let firstSelected = false;

          return {
            ...consignor,
            lr_list: consignor.lr_list.map((lr, index) => {

              const isFirstLR = index === 0;
              let isSelected = isFirstLR; // By default, select the first LR.

              // If there's only one LR, select it automatically.
              if (consignor.lr_list.length === 1) {
                isSelected = true;
              }

              // Logic for highest freight
              if (
                isHighestFreight &&
                lr.contract_rates?.total_freight === highestFreight &&
                !firstSelected
              ) {
                isSelected = true;
                firstSelected = true; // Ensure only one highest freight LR is selected.
              }

              // Handle multiple rates allowed condition
              if (multipleRatesAllowed) {
                // Allow other checkboxes to be checked, even if highest freight is selected.
                if (isHighestFreight) {
                  isSelected =
                    lr.contract_rates?.total_freight === highestFreight ||
                    lr.contract_rates?.qty > 0;
                }
              } else {
                // If multiple rates are not allowed, only select the highest freight
                if (
                  isHighestFreight &&
                  lr.contract_rates?.total_freight !== highestFreight
                ) {
                  isSelected = false; // Deselect if not the highest freight.
                }
              }

              return {
                ...lr,
                ...(lr.contract_rates?.freight_type
                  ? {
                    contract_rates: {
                      ...lr.contract_rates,
                      qty: 0,
                      selected: isSelected,
                    },
                  }
                  : {
                    contract_rates: {
                      freight_type: 6,
                      qty: 0,
                      rate: 0,
                      selected: false,
                      total_freight: 0,
                    },
                  }),
                ...(lr.lr_freight?.freight_type
                  ? {
                    lr_freight: {
                      ...lr.lr_freight,
                      qty: 0,
                      selected: isSelected,
                    },
                  }
                  : {
                    lr_freight: {
                      freight_type: 6,
                      qty: 0,
                      rate: 0,
                      selected: false,
                      total_freight: 0,
                    },
                  }),
              };
            }),
          };
        });

        setListOfFreight(updatedData);
      }
    } catch (error) {
      console.error("Error fetching contract rates", error);
    } finally {
      setLoading(false);
    }
  }, [filteredArray1, formValue, ownerShip, setListOfFreight]);

  useEffect(() => {
    if (separateLr || formValue || ownerShip) {
      fetchContractRates();
    }
  }, [separateLr, formValue, ownerShip, fetchContractRates]);

  const handleContractRateChange = useCallback(
    (consignorIndex, lrIndex, field, value, chargeable_on) => {
      setListOfFreight((prevList) => {

        const updatedData = [...prevList];

        const targetList = updatedData[consignorIndex].lr_list[lrIndex];
        // const targetRate = chargeable_on
        //   ? chargeable_on === 2
        //     ? targetList.contract_rates
        //     : targetList.lr_freight
        //   : targetList.contract_rates;

        const targetRate = targetList.contract_rates
        // const targetRate = chargeable_on == 2
        //   ? targetList.contract_rates
        //   : targetList.lr_freight


        if (field === "freight_type") {
          targetRate.qty = 0;
          targetRate.rate = 0;
          targetRate.amount = 0;
          targetRate.total_freight = 0;
        }

        if(targetRate.freight_type ==6 && field === "total_freight"){
          targetRate.rate = value;
        }
        targetRate[field] = value;

        if (targetRate?.freight_type != 6) {
          if (field === "rate" || field === "qty") {
            targetRate.total_freight = targetRate.rate * targetRate.qty || 0;
          }
        }

        return updatedData;
      });
    },
    [setListOfFreight]
  );

  const getFreightLabel = useCallback((freightType) => {
    switch (freightType) {
      case 1:
        return "KOT";
      case 2:
        return "Invoice";
      case 3:
        return "Kg";
      case 4:
        return "Qty";
      case 5:
        return "KMs";
      case 6:
        return "Flat";
      default:
        return "Qty";
    }
  }, []);

  const getFreightValue = useCallback(
    (contract, chargeableOn, contractRates, lrFreight) => {
      // return contract?._id
      //   ? chargeableOn === 2
      //     ? contractRates?.qty == 0 || contractRates?.qty == null
      //       ? ""
      //       : contractRates?.qty
      //     : lrFreight?.qty == 0 || lrFreight?.qty == null
      //       ? ""
      //       : lrFreight?.qty
      //   : contractRates?.qty == 0 || contractRates?.qty == null
      //     ? ""
      //     : contractRates?.qty;

      return contract?._id && contractRates?.qty == 0 || contractRates?.qty == null
        ? ""
        : contractRates?.qty;
    },
    []
  );

  const isFreightDisabled = useCallback(
    (consignor, chargeableOn, contractRates, lrFreight) => {
      // return consignor?._id
      //   ? chargeableOn === 2
      //     ? contractRates?.freight_type == 6
      //     : lrFreight?.freight_type === 6
      //   : contractRates?.freight_type === 6;

      return contractRates?.freight_type === 6;
    },
    []
  );



  const isEmpty = (obj) => Object.keys(obj).length === 0;

  function calculateFreight(lr, item, consignorIndex, lrIndex) {
    if (lr?.contract?._id) {
      // if (lr?.contract?.chargeable_on == 2) {
      if (!item?.contract_rates?.freight_type) {
        return 0;
      } else {
        if (item?.contract_rates?.freight_type !== 6) {
          const freight =
            item?.contract_rates?.qty * item?.contract_rates?.rate;

          return freight === 0 ? "" : freight;
        } else {
          return item?.contract_rates?.total_freight === 0
            ? ""
            : item?.contract_rates?.total_freight;
        }
      }
      // } else {
      //   if (item?.lr_freight?.freight_type !== 6) {
      //     const freight = item?.lr_freight?.qty * item?.lr_freight?.rate;
      //     return freight === 0 ? "" : freight;
      //   } else {
      //     return item?.lr_freight?.total_freight === 0
      //       ? ""
      //       : item?.lr_freight?.total_freight;
      //   }
      // }
    } else {
      // if (!item?.contract_rates?.freight_type) {
      //   return 0;
      // } else {
      //   if (item?.contract_rates?.freight_type !== 6) {
      //     const freight =
      //       item?.contract_rates?.qty * item?.contract_rates?.rate;

      //     return freight === 0 ? "" : freight;
      //   } else {
      //     return item?.contract_rates?.total_freight === 0
      //       ? ""
      //       : item?.contract_rates?.total_freight;
      //   }
      // }
      // if (lr?.contract?.chargeable_on == 2) {
      if (!item?.contract_rates?.freight_type) {
        return 0;
      } else {
        if (item?.contract_rates?.freight_type !== 6) {
          const freight =
            item?.contract_rates?.qty * item?.contract_rates?.rate;

          return freight === 0 ? "" : freight;
        } else {
          return item?.contract_rates?.total_freight === 0
            ? ""
            : item?.contract_rates?.total_freight;
        }
      }
      // } else {
      //   if (item?.lr_freight?.freight_type !== 6) {
      //     const freight = item?.lr_freight?.qty * item?.lr_freight?.rate;
      //     return freight === 0 ? "" : freight;
      //   } else {
      //     return item?.lr_freight?.total_freight === 0
      //       ? ""
      //       : item?.lr_freight?.total_freight;
      //   }
      // }
    }
  }

  const shouldDisableCheckbox = (item, consignorIndex, lr) => {
    const isChargeableOn = lr?.contract?.chargeable_on === 2;
    const isHighestFreight = lr.contract.highest_freight === 1;
    const multipleRatesAllowed = lr.contract.multiple_rates_allowed === 1;
    // When both are 0, disable all checkboxes
    if (!multipleRatesAllowed && !isHighestFreight) {
      return true; // Disable all checkboxes
    }

    if (isHighestFreight && !multipleRatesAllowed) {
      return true; // Disable all other checkboxes when highest freight is selected but multiple rates not allowed
    }

    // if (isChargeableOn) {
    const selectedCount = listOfFreight[consignorIndex].lr_list.filter(
      (lr) => lr.contract_rates.selected
    ).length;
    return selectedCount <= 1 && item?.contract_rates?.selected;
    // } else {
    //   const selectedCount = listOfFreight[consignorIndex].lr_list.filter(
    //     (lr) => lr.lr_freight.selected
    //   ).length;
    //   return selectedCount <= 1 && item?.lr_freight?.selected;
    // }
  };

  function extractLRData(data) {
    return data
      .map((consignor) =>
        consignor.lr_list.map((lr) => {
          return {
            consignor_id: consignor.consignor_id,
            lr_id: lr._id || "",
            from: lr?.from,
            to: lr?.to,
            qty: lr?.contract_rates?.qty,
            rate: lr?.contract_rates?.rate,
            total_freight: lr?.contract_rates?.total_freight,
            freight_type: lr?.contract_rates?.freight_type,
            // If _id exists, use it; otherwise, keep it empty
          };
        })
      )
      .flat(); // Flatten the array
  }

  const result = extractLRData(listOfFreight);

  const inhanceProps = {
    ...props,
  };

  return (
    <CommonModal {...inhanceProps}>
      <div className="_lrFreightBody">
        {separateLr ? (
          listOfFreight?.map((lr, consignorIndex) => (
            <div className="_lrxAll" key={`fr${consignorIndex}`}>

              <h4 className="lrfHead">{lr?.lr_list[0]?.consignor_id?.name}</h4>
              {lr?.lr_list?.map((item, lrIndex) => {

                const freightTypeOption = lr?.contract?._id ? lr?.contract?.rate_type : freightTYpeList;
                const generateRandomId = () => {
                  return `checkbox-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
                };
                return (
                  <div className="_lrx_flx" key={`fr${lrIndex}`}>
                    <div className=" fright_size">
                      <CommonInput
                        type="text"
                        label="Contract Description"
                        value={item?.contract_id?.name}
                        disabled
                      />
                    </div>
                    <div className=" fright_size">
                      <CommonInput
                        type="text"
                        label="Route"
                        value={`${item?.from_location} - ${item?.to_location}`}
                        disabled
                      />
                    </div>
                    <div className=" fright_size">
                      <CommonInput
                        type="text"
                        label="Invoice Number"
                        value={item?.invoice_number}
                        disabled
                      />
                    </div>


                    <div className="md_size">
                      <CustomSelect
                        label="Freight Type"
                        value={{
                          label:
                            freightTypeOption?.find(
                              (i) =>
                                i?.id ===
                                (lr?.contract?._id
                                  ? lr?.contract?.chargeable_on === 2
                                    ? item?.contract_rates?.freight_type
                                    : item?.contract_rates?.freight_type
                                  : item?.contract_rates?.freight_type)
                            )?.name || "Flat Rate",
                          value:
                            freightTypeOption?.find(
                              (i) =>
                                i?.id ===
                                (lr?.contract?._id
                                  ? lr?.contract?.chargeable_on === 2
                                    ? item?.contract_rates?.freight_type
                                    : item?.contract_rates?.freight_type
                                  : item?.contract_rates?.freight_type)
                            )?.id || 6,
                        }}
                        options={
                          freightTypeOption?.map((v) => ({
                            label: v.name,
                            value: v.id,
                          })) || []
                        }
                        onSelect={(data) =>
                          handleContractRateChange(
                            consignorIndex,
                            lrIndex,
                            "freight_type",
                            data?.value,
                            lr?.contract?.chargeable_on
                          )
                        }
                        maxLength={4}

                      />
                    </div>

                    <div className=" md_size">
                      <CommonInput
                        type="text"
                        label={getFreightLabel(
                          lr?.contract?.chargeable_on == 2
                            ? item?.contract_rates?.freight_type
                            : item?.contract_rates?.freight_type
                        )}
                        value={getFreightValue(
                          lr?.contract,
                          lr?.contract?.chargeable_on,
                          item?.contract_rates,
                          item?.contract_rates
                        )}
                        // disabled={isFreightDisabled(lr?.contract?.chargeable_on, item?.contract_rates, item?.lr_freight)}
                        disabled={isFreightDisabled(
                          lr?.contract,
                          lr?.contract?.chargeable_on,
                          item?.contract_rates,
                          item?.contract_rates
                        )}
                        onKeyDown={handleKeyDown}
                        onChange={(e) =>
                          handleContractRateChange(
                            consignorIndex,
                            lrIndex,
                            "qty",
                            Number(e.target?.value),
                            lr?.contract?.chargeable_on
                          )
                        }
                        maxLength={4}
                      />
                    </div>
                    <div className=" md_size">
                      <CommonInput
                        type="text"
                        label="Rate"
                        value={
                          lr?.contract?._id
                            ? lr?.contract?.chargeable_on === 2
                              ? item?.contract_rates?.rate == 0 ||
                                item?.contract_rates?.rate == null
                                ? ""
                                : item?.contract_rates?.rate
                              : item?.contract_rates?.rate == 0 ||
                                item?.contract_rates?.rate == "undefined"
                                ? ""
                                : item?.contract_rates?.rate
                            : item?.contract_rates?.rate == 0 ||
                              item?.contract_rates?.rate == null
                              ? ""
                              : item?.contract_rates?.rate
                        }

                        disabled={isFreightDisabled(
                          lr?.contract?.consignor_id,
                          lr?.contract?.chargeable_on,
                          item?.contract_rates,
                          item?.contract_rates
                        )}
                        onKeyDown={handleKeyDown}
                        onChange={(e) =>
                          handleContractRateChange(
                            consignorIndex,
                            lrIndex,
                            "rate",
                            Number(e.target?.value),
                            lr?.contract?.chargeable_on
                          )
                        }
                        maxLength={4}
                      />
                    </div>
                    <div className=" md_size">
                      {lr?.contract?.visibility != 0 && (
                        <CommonInput
                          type="text"
                          label="Amount (₹)"
                          value={calculateFreight(
                            lr,
                            item,
                            consignorIndex,
                            lrIndex
                          )}
                          disabled={
                            lr?.contract?._id
                              ? lr?.contract?.visibility == 2
                                ? !isFreightDisabled(
                                  lr?.contract?._id,
                                  lr?.contract?.chargeable_on,
                                  item?.contract_rates,
                                  item?.contract_rates
                                )
                                : true
                              : item?.contract_rates?.freight_type !== 6
                          }
                          // disabled={!isFreightDisabled(lr?.contract?.chargeable_on, item?.contract_rates, item?.lr_freight)}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleContractRateChange(
                              consignorIndex,
                              lrIndex,
                              "total_freight",
                              Number(e.target?.value),
                              lr?.contract?.chargeable_on
                            )
                          }
                          maxLength={7}
                        />
                      )}

                    </div>
                    {lr?.contract?.multiple_rates_allowed == 1 && <div className="smCheck">
                      <Checkbox
                        type="checkbox"
                        id={item?._id || generateRandomId()}
                        isChecked={
                          lr?.contract?._id
                            ? lr?.contract?.chargeable_on === 2
                              ? item?.contract_rates?.selected
                              : item?.contract_rates?.selected
                            : item?.contract_rates?.selected
                        }


                        isDisabled={
                          lr?.contract?._id
                            ? shouldDisableCheckbox(
                              item,
                              consignorIndex,
                              lr,
                              listOfFreight
                            )
                            : false
                        }
                        handleClick={(e) =>
                          handleContractRateChange(
                            consignorIndex,
                            lrIndex,
                            "selected",
                            e.target.checked,
                            lr?.contract?.chargeable_on
                          )
                        }
                      />
                    </div>}
                  </div>
                );
              })}
            </div>
          ))
        ) : (
          <>Loadding..</>
        )}
      </div>
    </CommonModal>
  );
};

export default LrFreightModal2;
